import Footer from "../component/Footer"
import Home from "../component/Home"
import Navbar from "../component/navbar/Navbar"

export default function HomePage(){
     return(<>

            <Navbar/>
            
            <Home/>
            <Footer/>
     </>
     )
}